import { useTranslation } from "react-i18next";
import { useOperationsMap } from "../OperationsMapProvider";
import { Button, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { Close as CloseIcon, OpenInNew as OpenIcon, ArrowBack as BackIcon } from "@mui/icons-material";
import { makeStyles } from "tss-react/mui";
import { useCallback, useMemo } from "react";
import TaskQuickView from "../../../common/task/QuickView/TaskQuickView";
import { EntityContextProvider } from "@emberly/zenith-client";
import MissionContextProvider from "../../../../providers/MissionProvider";
import ResponsiveDialog from "../../../common/core/ResponsiveDialog";
import TaskStateChip from "../../../common/display/TaskStateChip";
import { GetTaskDriverState } from "../../../../common/mission";
import { CompactTimeView } from "../../../common/core/Time";
import { useDevice } from "../../../../providers/DeviceProvider";
import { useNavigate } from "react-router";
import { useDispatch } from "../../dispatch/providers/DispatchProvider";


const useStyles = makeStyles()(
  (theme) => ({
    timeLabel: {
      color: theme.palette.text.secondary,
      fontSize: "12px"
    },
    titleContainer: {
      display: "flex",
      alignItems: "center"
    },
    stateChip: {
      marginLeft: theme.spacing(2),
      borderRadius: theme.spacing(0.5),
      fontWeight: 400,
      fontSize: "14px"
    },
    closeButton: {
      marginLeft: theme.spacing(-1),
      marginRight: theme.spacing(1)
    },
    openButton: {
      marginLeft: "auto"
    }
  })
);

export default function TaskDialog() {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const { slim } = useDevice();
  const navigate = useNavigate();

  const {
    closeTaskDialog,
    taskId
  } = useOperationsMap();

  const  { activeTasks } = useDispatch();

  const task = useMemo(() => activeTasks.find(t => t.id === taskId), [taskId, activeTasks]);

  const openFullMissionView = useCallback((params, ev) => {
    navigate(`./${task.id}`, { relative: "path" });
  }, [navigate, task]);


  return !!task ? (
    <ResponsiveDialog
      open
      onClose={closeTaskDialog}
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle className={classes.titleContainer}>


        <IconButton onClick={closeTaskDialog} size="small" color="primary" className={classes.closeButton}>
          {slim ? <BackIcon /> : <CloseIcon />}
        </IconButton>

        {task.missionNumber}.{task.number} - {task.taskName || t("operationsMap:taskDefaultName")}

        {
          slim ? (
            <IconButton onClick={openFullMissionView} size="small" color="primary" className={classes.openButton}>
              <OpenIcon />
            </IconButton>
          ) : (
            <>
              <TaskStateChip
                size="small"
                className={classes.stateChip}
                state={task.state}
                driverAssignedState={task.execution.driverAssignedState}
                label={
                  <>
                    {GetTaskDriverState(task.execution.driverAssignedState, task.state, t, true)}
                    {!!task.stateData?.lastModified ? <span className={classes.timeLabel}>&nbsp;(<CompactTimeView refresh={Date.now()} time={task.stateData?.lastModified} />)</span> : null}
                  </>
                }
              />

              <Button onClick={openFullMissionView} variant="contained" color="neutral" className={classes.openButton}>
                {t("taskQuickView:openMission")}
              </Button>
            </>
          )
        }
      </DialogTitle>

      <DialogContent>
        <EntityContextProvider id={task.missionId} type="Mission">
          <MissionContextProvider>
            <TaskQuickView task={task} />
          </MissionContextProvider>
        </EntityContextProvider>
      </DialogContent>

    </ResponsiveDialog>
  ) : null;
}

